import { LocaleMap, Locales, LocaleType } from "@/hooks/locale/useChangeLocale/types";
import queryString from "querystring";

export const queryToStringArray = (value: string[] | string | undefined): string[] => {
  if (Array.isArray(value)) {
    return value.map(i => i);
  }
  if (value) {
    return [value];
  }
  return [];
};

export const queryToNumberArray = (value: string[] | string | undefined): number[] => {
  if (Array.isArray(value)) {
    return value.map(i => +i);
  }
  if (value) {
    return [+value];
  }
  return [];
};

function declOfNumUK(forms: string[], count: number) {
  if (!forms || forms.length < 3) return "";

  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (lastDigit === 1 && lastTwoDigits !== 11) {
    return forms[0];
  }

  if (lastDigit >= 2 && lastDigit <= 4 && !(lastTwoDigits >= 12 && lastTwoDigits <= 14)) {
    return forms[1];
  }

  return forms[2];
}

export const pluralize = (forms: string[], count: number, local: LocaleType): string => {
  if (local === Locales.UK) {
    return declOfNumUK(forms, count);
  }

  return count <= 1 ? forms[0] : forms[1];
};

export const getLocalPrice = (local: LocaleType): string => {
  const localPrices: LocaleMap<string> = {
    en: "",
    da: "",
    de: "",
    fr: "",
    uk: "грн",
    ro: "",
    be: "",
    nl: "",
  };

  return localPrices[local];
};

export const getCleanQuerystring = (
  queryObject: NodeJS.Dict<
    string | number | boolean | readonly string[] | readonly number[] | readonly boolean[] | null
  >,
) => {
  const filteredQueryObject = Object.fromEntries(
    Object.entries(queryObject).filter(([_, value]) => {
      return value !== null && value !== undefined && value !== "";
    }),
  );

  return queryString.stringify(filteredQueryObject);
};
